// App.js
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { PropertyProvider } from './Book ON Nile/PropertyContext';

// Login Screens
import PropertyLogin from './Book ON Nile/Login Forms/PropertyLogin';
import Reservationlogin from './Book ON Nile/Login Forms/Reservationlogin';
import AgentLoginForm from './Book ON Nile/Login Forms/AgentLoginForm';
import CorporateLogin from './Book ON Nile/Login Forms/CorporateLogin';
import Forgotpassword from './Book ON Nile/Login Forms/Forgotpassword';
import OtpVerification from './Book ON Nile/Login Forms/OtpVerification';
import ResetPassword from './Book ON Nile/Login Forms/ResetPassword';

// Protected Route Components
import PrivateRouteProperty from './Book ON Nile/ProtectedRoutes/PrivateRouteProperty';
import PrivateRouteReservation from './Book ON Nile/ProtectedRoutes/PrivateRouteReservation';
import PrivateRouteAgent from './Book ON Nile/ProtectedRoutes/PrivateRouteAgent';

// Property Pages
import PropertyDetails from './Book ON Nile/Property pages/Property details/PropertyDetails';
import Contact from './Book ON Nile/Property pages/Property details/Contact';
import ProprtyLocation from './Book ON Nile/Property pages/Property details/ProprtyLocation';
import Amenities from './Book ON Nile/Property pages/Property details/Amenities';
import Bankdetail from './Book ON Nile/Property pages/Property details/Bankdetail';
import GstDetail from './Book ON Nile/Property pages/Property details/GstDetail';
import Room from './Book ON Nile/Property pages/Property details/Room';
// import RoomCreate from './Book ON Nile/Property pages/Property details/RoomCreate';
import { Dashboard } from './Book ON Nile/Property pages/Dashboard/Dashboard';

import NewBooking from './Book ON Nile/Property pages/Booking Details/NewBooking';
import BookingList from './Book ON Nile/Property pages/Booking Details/BookingList';
import BulkUpdateForm from './Book ON Nile/Property pages/Introverty details/BulkUpdateForm';
import InventoryUpdate from './Book ON Nile/Property pages/Introverty details/InventoryUpdate';
import InventoryUpdateForm from './Book ON Nile/Property pages/Introverty details/InventoryUpdateForm';
import RateUpdateForm from './Book ON Nile/Property pages/Introverty details/RateUpdateForm';

import NewAgent from './Book ON Nile/Property pages/agent detail/NewAgent';
import Agentlist from './Book ON Nile/Property pages/agent detail/Agentlist';
import EditAgentData from './Book ON Nile/Property pages/agent detail/EditAgentData';

import NewUser from './Book ON Nile/Property pages/User Detail/NewUser';

import NewCompany from './Book ON Nile/Property pages/Company Detail/NewCompany';
import CompanyList from './Book ON Nile/Property pages/Company Detail/CompanyList';
import EditCompanyData from './Book ON Nile/Property pages/Company Detail/EditCompanyData';

// Reservation Pages
import ReservationBooking from './Book ON Nile/reservation pages/ReservationBooking';
// import ReservationBookingList from './Book ON Nile/reservation pages/ReservationBookingList';
// import BookingVoucherPage from './Book ON Nile/reservation pages/BookingVoucherPage';

// Agent Pages
import { AgentBooking } from './Book ON Nile/Agent Pages/AgentBooking';
import { AgentBookingList } from './Book ON Nile/Agent Pages/AgentBookingList';
import { AgentRooms } from './Book ON Nile/Agent Pages/AgentRooms';
import { AgentRoomselect } from './Book ON Nile/Agent Pages/AgentRoomselect';
import { AddGuestdetails } from './Book ON Nile/Agent Pages/AddGuestdetails';
import { PaymentIframe } from './Book ON Nile/Agent Pages/PaymentIframe';

// Frontend Pages
import Home from './Book ON Nile/BON Frontend/Home/Home';
import Header from './Book ON Nile/BON Frontend/Commun/Header';
import { NewPage } from './Book ON Nile/Property pages/Booking Details/NewPage';
import Voucher from './Book ON Nile/reservation pages/voucher';
import { EditBooking } from './Book ON Nile/Property pages/Booking Details/EditBooking';
import { MarketSegmentList } from './Book ON Nile/Property pages/Market Segmant/MarketSegmentList';
import { BusinessSourceList } from './Book ON Nile/Property pages/Business Source/BusinessSourceList';
import { MealPlan } from './Book ON Nile/Property pages/Property details/MealPlan';
import { RateCode } from './Book ON Nile/Property pages/Property details/RateCode';
import { RateInventory } from './Book ON Nile/Property pages/Property details/RateInventory';
import { PropertyBookingVoucher } from './Book ON Nile/Property pages/Booking Details/Booking Voucher/PropertyBookingVoucher';

import VoucherEdit from './Book ON Nile/Property pages/Booking Details/Booking Voucher/VoucherEdit';
import AgentBookingconfirm from './Book ON Nile/Agent Pages/AgentBookingconfirm';
import Deshboard from './Book ON Nile/reservation pages/Deshboard';
import ReservationNewAgent from './Book ON Nile/reservation pages/Agent Details/NewAgent';
import ReservationAgentlist from './Book ON Nile/reservation pages/Agent Details/AgentList';
import ReservationNewCompany from './Book ON Nile/reservation pages/Company Details/NewCompany';
import ReservationCompanyList from './Book ON Nile/reservation pages/Company Details/Companylist';
import { ReservationMarketSegment } from './Book ON Nile/reservation pages/Market Segment/MarketSegment';
import { ReservationBusinessSource } from './Book ON Nile/reservation pages/Business Source/BusinessSource';
import { ReservationRatecode } from './Book ON Nile/reservation pages/Property Details/RateCode';
import { ReservationMealPlan } from './Book ON Nile/reservation pages/Property Details/MealPlan';
import { ReservationRateInventory } from './Book ON Nile/reservation pages/Property Details/RateInventory';
import { GuaranteeCodes } from './Book ON Nile/Property pages/Guarantee Codes/GuaranteeCodes';
import { ReservationGuaranteeCodes } from './Book ON Nile/reservation pages/Guarantee Codes/GuaranteeCodes';
import { Report } from './Book ON Nile/Property pages/Reports/Report';
import { AgentBookingReport } from './Book ON Nile/Property pages/Reports/AgentBookingReport';
import { TodayBookingReport } from './Book ON Nile/Property pages/Reports/TodayBookingReport';
import { BookingReort } from './Book ON Nile/Property pages/Reports/BookingReort';
import BulkUpdateCalender from './Book ON Nile/Property pages/Property details/Bulk Update/BulkUpdateCalender';
import { BulkUpdateRate } from './Book ON Nile/Property pages/Property details/Bulk Update/BulkUpdatePage';
import { BookingSearch } from './Book ON Nile/reservation pages/Booking Details/BookingSearch';
import ReserNewBooking from './Book ON Nile/reservation pages/Booking Details/ReserNewBooking';
import ReserBookingList from './Book ON Nile/reservation pages/Booking Details/BookingList';






// import EditBookings from './Book ON Nile/Property pages/Booking Details/EditBooking';


function App() {
  return (
    <PropertyProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/Forgotpassword" element={<Forgotpassword />} />
          <Route path='/VerifyOTP' element={<OtpVerification />} />
          <Route path='/ResetPassword' element={<ResetPassword />} />
          <Route path="/header" element={<Header />} />

          {/* Login Pages */}
          <Route path="/Property/Login" element={<PropertyLogin />} />
          <Route path="/Reservation/login" element={<Reservationlogin />} />
          <Route path="/Agent/login" element={<AgentLoginForm />} />
          <Route path="/corporatelogin" element={<CorporateLogin />} />

          {/* Property Protected Routes */}
          <Route path="/Property/propertyDetails" element={<PrivateRouteProperty><PropertyDetails /></PrivateRouteProperty>} />
          <Route path="/Property/contact" element={<PrivateRouteProperty><Contact /></PrivateRouteProperty>} />
          <Route path="/Property/propertylocation" element={<PrivateRouteProperty><ProprtyLocation /></PrivateRouteProperty>} />
          <Route path="/Property/Amenities" element={<PrivateRouteProperty><Amenities /></PrivateRouteProperty>} />
          <Route path="/Property/Bankdetail" element={<PrivateRouteProperty><Bankdetail /></PrivateRouteProperty>} />
          <Route path="/Property/room" element={<PrivateRouteProperty><Room /></PrivateRouteProperty>} />
          <Route path="/Property/Gstdetail" element={<PrivateRouteProperty><GstDetail /></PrivateRouteProperty>} />
          <Route path="/Property/NewAgent" element={<PrivateRouteProperty><NewAgent /></PrivateRouteProperty>} />
          <Route path="/Property/AgentList" element={<PrivateRouteProperty><Agentlist /></PrivateRouteProperty>} />
          <Route path="/Property/EditAgentData" element={<PrivateRouteProperty><EditAgentData /></PrivateRouteProperty>} />
          <Route path="/Property/NewUser" element={<PrivateRouteProperty><NewUser /></PrivateRouteProperty>} />
          <Route path="/Property/Newcompany" element={<PrivateRouteProperty><NewCompany /></PrivateRouteProperty>} />
          <Route path="/Property/Updatecompany/:id" element={<PrivateRouteProperty><NewCompany /></PrivateRouteProperty>} />
          <Route path="/Property/companyList" element={<PrivateRouteProperty><CompanyList /></PrivateRouteProperty>} />
          <Route path="/Property/EditCompanyData" element={<PrivateRouteProperty><EditCompanyData /></PrivateRouteProperty>} />
          {/* <Route path="/Property/RoomCreate" element={<PrivateRouteProperty><RoomCreate /></PrivateRouteProperty>} /> */}
          <Route path="/Property/Dashboard" element={<PrivateRouteProperty><Dashboard /></PrivateRouteProperty>} />
          <Route path="/Property/NewBooking" element={<PrivateRouteProperty><NewPage /></PrivateRouteProperty>} />
          <Route path="/Property/EditBooking" element={<PrivateRouteProperty><EditBooking /></PrivateRouteProperty>} />
          <Route path="/Property/FinalBooking" element={<PrivateRouteProperty><NewBooking /></PrivateRouteProperty>} />
          <Route path="/Property/BookingVoucher" element={<PrivateRouteProperty><PropertyBookingVoucher /></PrivateRouteProperty>} />
          <Route path="/Property/Bookinglist" element={<PrivateRouteProperty><BookingList /></PrivateRouteProperty>} />
          <Route path="/Property/Bulkupdateform" element={<PrivateRouteProperty><BulkUpdateForm /></PrivateRouteProperty>} />
          <Route path="/Property/InventoryUpdate" element={<PrivateRouteProperty><InventoryUpdate /></PrivateRouteProperty>} />
          <Route path="/Property/InventoryUpdateForm" element={<PrivateRouteProperty><InventoryUpdateForm /></PrivateRouteProperty>} />
          <Route path="/Property/RateUpdateForm" element={<PrivateRouteProperty><RateUpdateForm /></PrivateRouteProperty>} />

          <Route path="/Property/MarketSagmentList" element={<PrivateRouteProperty><MarketSegmentList /></PrivateRouteProperty>} />
          <Route path="/Property/BusinessSourceList" element={<PrivateRouteProperty><BusinessSourceList /></PrivateRouteProperty>} />
          <Route path="/Property/MealPlanList" element={<PrivateRouteProperty><MealPlan /></PrivateRouteProperty>} />
          <Route path="/Property/RateCodeList" element={<PrivateRouteProperty><RateCode /></PrivateRouteProperty>} />
          <Route path="/Property/RateInventory" element={<PrivateRouteProperty><RateInventory /></PrivateRouteProperty>} />
          <Route path="/Property/BulkUpdateCalender" element={<PrivateRouteProperty>< BulkUpdateCalender /></PrivateRouteProperty>} />
          <Route path="/Property/BulkUpdateRate" element={<PrivateRouteProperty>< BulkUpdateRate /></PrivateRouteProperty>} />
          <Route path="/Property/VoucherEdit" element={<PrivateRouteProperty><VoucherEdit /></PrivateRouteProperty>} />
          <Route path="/Property/GuaranteeCodes" element={<PrivateRouteProperty><GuaranteeCodes /></PrivateRouteProperty>} />
          <Route path="/Property/Report" element={<PrivateRouteProperty><Report /></PrivateRouteProperty>} />
          <Route path="/Property/AgentReport" element={<PrivateRouteProperty><AgentBookingReport /></PrivateRouteProperty>} />
          <Route path="/Property/TodayBookingReport" element={<PrivateRouteProperty><TodayBookingReport /></PrivateRouteProperty>} />
          <Route path="/Property/BookingReport" element={<PrivateRouteProperty><BookingReort /></PrivateRouteProperty>} />

          {/* Reservation Protected Routes */}
          <Route path="/Reservation/Dashboard" element={<PrivateRouteReservation><Deshboard /></PrivateRouteReservation>} />
          <Route path="/Reservation/Booking" element={<PrivateRouteReservation><ReservationBooking /></PrivateRouteReservation>} />
          {/* <Route path="/Reservation/Bookinglist" element={<PrivateRouteReservation><ReservationBookingList /></PrivateRouteReservation>} /> */}
          {/* <Route path="/Reservation/bookingvoucher" element={<PrivateRouteReservation><BookingVoucherPage /></PrivateRouteReservation>} /> */}
          <Route path="/Reservation/bookingvoucher" element={<PrivateRouteReservation><Voucher /></PrivateRouteReservation>} />
          <Route path="/Reservation/NewAgent" element={<PrivateRouteReservation><ReservationNewAgent /></PrivateRouteReservation>} />
          <Route path="/Reservation/AgentList" element={<PrivateRouteReservation><ReservationAgentlist /></PrivateRouteReservation>} />
          <Route path="/Reservation/NewCompany" element={<PrivateRouteReservation><ReservationNewCompany /></PrivateRouteReservation>} />
          <Route path="/Reservation/CompanyList" element={<PrivateRouteReservation><ReservationCompanyList /></PrivateRouteReservation>} />
          <Route path="/Reservation/Updatecompany/:id" element={<PrivateRouteReservation><ReservationNewCompany /></PrivateRouteReservation>} />
          <Route path="/Reservation/MarketSegment" element={<PrivateRouteReservation><ReservationMarketSegment /></PrivateRouteReservation>} />
          <Route path="/Reservation/BusinessSource" element={<PrivateRouteReservation><ReservationBusinessSource /></PrivateRouteReservation>} />
          <Route path="/Reservation/RateCode" element={<PrivateRouteReservation><ReservationRatecode /></PrivateRouteReservation>} />
          <Route path="/Reservation/MealPlan" element={<PrivateRouteReservation><ReservationMealPlan /></PrivateRouteReservation>} />
          <Route path="/Reservation/RateInventory" element={<PrivateRouteReservation><ReservationRateInventory /></PrivateRouteReservation>} />
          <Route path="/Reservation/GuaranteeCodes" element={<PrivateRouteReservation><ReservationGuaranteeCodes /></PrivateRouteReservation>} />
          {/* Reservation new Page of Bookings */}
          <Route path="/Reservation/NewBooking" element={<PrivateRouteReservation><BookingSearch /></PrivateRouteReservation>} />
          <Route path="/Reservation/FinalBooking" element={<PrivateRouteReservation><ReserNewBooking /></PrivateRouteReservation>} />
          <Route path="/Reservation/Bookinglist" element={<PrivateRouteReservation><ReserBookingList /></PrivateRouteReservation>} />


          {/* Agent Protected Routes */}
          <Route path="/Agent/Booking" element={<PrivateRouteAgent><AgentBooking /></PrivateRouteAgent>} />
          <Route path="/Agent/Bookinglist" element={<PrivateRouteAgent><AgentBookingList /></PrivateRouteAgent>} />
          <Route path="/Agent/rooms" element={<PrivateRouteAgent><AgentRooms /></PrivateRouteAgent>} />
          <Route path="/Agent/roomselected" element={<PrivateRouteAgent><AgentRoomselect /></PrivateRouteAgent>} />
          <Route path="/Agent/AddGuestDetails" element={<PrivateRouteAgent><AddGuestdetails /></PrivateRouteAgent>} />
          <Route path="/Agent/Payment" element={<PrivateRouteAgent><PaymentIframe /></PrivateRouteAgent>} />
          <Route path="/Agent/BookingConfirm" element={<PrivateRouteAgent><AgentBookingconfirm /></PrivateRouteAgent>} />

        </Routes>
      </BrowserRouter>
    </PropertyProvider>
  );
}

export default App;
